// Importa a declaração de tipos
/// <reference path="./vite-env.d.ts" />

const node_env = import.meta.env.VITE_NODE_ENV || 'development';

const envModes = {
    development: "DEV",
    dev: "DEV",
    develop: "DEV",
    homolog: "HMG", 
    homologation: "HMG",
    hmg: "HMG",
    production: "PRD",
    prod: "PRD",
    prd: "PRD",
    local: "LOCAL"
} as const;

type EnvMode = keyof typeof envModes;

const values = {
    NODE_ENV: node_env,
    APP_TITLE: import.meta.env.VITE_APP_TITLE || "Chatbot",
    APP_DESCRIPTION: import.meta.env.VITE_APP_DESCRIPTION || "Assistente Virtual",
    APP_ASSISTANT_NAME: import.meta.env.VITE_APP_ASSISTANT_NAME || "Assistente",
    PUBLIC_URL: import.meta.env.VITE_PUBLIC_URL || "",
    PORT: import.meta.env.VITE_PORT || "3000",
    API_URL: import.meta.env.VITE_API_URL || "http://localhost:8080",
    SUBSCRIPTION_KEY: import.meta.env.VITE_SUBSCRIPTION_KEY || "",
    VITE_ID_SHOPPING_TIJUCA: import.meta.env.VITE_ID_SHOPPING_TIJUCA || "",
    VITE_ID_SHOPPING_BANGU: import.meta.env.VITE_ID_SHOPPING_BANGU || "",
    VITE_ID_SHOPPING_GRANDE_RIO: import.meta.env.VITE_ID_SHOPPING_GRANDE_RIO || "",
    VITE_ID_SHOPPING_PARQUE_D_PEDRO: import.meta.env.VITE_ID_SHOPPING_PARQUE_D_PEDRO || "",
    VITE_ID_SHOPPING_CAXIAS: import.meta.env.VITE_ID_SHOPPING_CAXIAS || "",
    VITE_ID_SHOPPING_NORTE: import.meta.env.VITE_ID_SHOPPING_NORTE || "",
    VITE_ID_SHOPPING_VILA_VELHA: import.meta.env.VITE_ID_SHOPPING_VILA_VELHA || "",
    VITE_ID_SHOPPING_PARANGABA: import.meta.env.VITE_ID_SHOPPING_PARANGABA || "",
    VITE_ID_SHOPPING_DA_BAHIA: import.meta.env.VITE_ID_SHOPPING_DA_BAHIA || "",
    VITE_ID_SHOPPING_DEL_REY: import.meta.env.VITE_ID_SHOPPING_DEL_REY || "",
    VITE_ID_SHOPPING_BOULEVARD_BH: import.meta.env.VITE_ID_SHOPPING_BOULEVARD_BH || "",
    VITE_ID_SHOPPING_ESTACAO_BH: import.meta.env.VITE_ID_SHOPPING_ESTACAO_BH || "",
    VITE_ID_SHOPPING_PLAZA_NITEROI: import.meta.env.VITE_ID_SHOPPING_PLAZA_NITEROI || "",
    VITE_ID_SHOPPING_TABOAO: import.meta.env.VITE_ID_SHOPPING_TABOAO || "",
    VITE_ID_SHOPPING_CARIOCA: import.meta.env.VITE_ID_SHOPPING_CARIOCA || "",
    VITE_ID_SHOPPING_CAMPO_LIMPO: import.meta.env.VITE_ID_SHOPPING_CAMPO_LIMPO || "",
    
    VITE_ID_SHOPPING_PASSEIO_DAS_AGUAS: import.meta.env.VITE_ID_SHOPPING_PASSEIO_DAS_AGUAS || "",
    VITE_ID_SHOPPING_LEBLON: import.meta.env.VITE_ID_SHOPPING_LEBLON || "",
    VITE_ID_SHOPPING_MOOCA_PLAZA: import.meta.env.VITE_ID_SHOPPING_MOOCA_PLAZA || "",
    VITE_ID_SHOPPING_CENTER_UBERLANDIA: import.meta.env.VITE_ID_SHOPPING_CENTER_UBERLANDIA || "",
    VITE_ID_SHOPPING_PLAZA_SUL: import.meta.env.VITE_ID_SHOPPING_PLAZA_SUL || "",
    VITE_ID_SHOPPING_PIRACICABA: import.meta.env.VITE_ID_SHOPPING_PIRACICABA || "",
    VITE_ID_SHOPPING_TAMBORE: import.meta.env.VITE_ID_SHOPPING_TAMBORE || "",
    VITE_ID_SHOPPING_BOULEVARD_BELEM: import.meta.env.VITE_ID_SHOPPING_BOULEVARD_BELEM || "",
    VITE_ID_SHOPPING_ESTACAO_CUIABA: import.meta.env.VITE_ID_SHOPPING_ESTACAO_CUIABA || "",
    VITE_ID_SHOPPING_CARIRI: import.meta.env.VITE_ID_SHOPPING_CARIRI || "",
    VITE_ID_SHOPPING_INDEPENDENCIA: import.meta.env.VITE_ID_SHOPPING_INDEPENDENCIA || "",
    VITE_ID_SHOPPING_CATUAI_MARINGA: import.meta.env.VITE_ID_SHOPPING_CATUAI_MARINGA || "",
    VITE_ID_SHOPPING_CAMPO_GRANDE: import.meta.env.VITE_ID_SHOPPING_CAMPO_GRANDE || "",
    VITE_ID_SHOPPING_VILLA_LOBOS: import.meta.env.VITE_ID_SHOPPING_VILLA_LOBOS || "",
    VITE_ID_SHOPPING_CATUAI_LONDRINA: import.meta.env.VITE_ID_SHOPPING_CATUAI_LONDRINA || "",
    
    VITE_ID_SAO_BERNARDO_PLAZA_SHOPPING: import.meta.env.VITE_ID_SAO_BERNARDO_PLAZA_SHOPPING || "",
    VITE_ID_SHOPPING_VILLAGIO_CAXIAS: import.meta.env.VITE_ID_SHOPPING_VILLAGIO_CAXIAS || "",
    VITE_ID_MANAUARA_SHOPPING: import.meta.env.VITE_ID_MANAUARA_SHOPPING || "",
    VITE_ID_GOIANIA_SHOPPING: import.meta.env.VITE_ID_GOIANIA_SHOPPING || "",
    VITE_ID_RECREIO_SHOPPING: import.meta.env.VITE_ID_RECREIO_SHOPPING || "",
    VITE_ID_AMAZONAS_SHOPPING: import.meta.env.VITE_ID_AMAZONAS_SHOPPING || "",
    VITE_ID_PARQUE_SHOPPING_BELEM: import.meta.env.VITE_ID_PARQUE_SHOPPING_BELEM || "",
    VITE_ID_FRANCA_SHOPPING: import.meta.env.VITE_ID_FRANCA_SHOPPING || "",
    VITE_ID_SHOPPING_CURITIBA: import.meta.env.VITE_ID_SHOPPING_CURITIBA || "",
    VITE_ID_RIO_ANIL_SHOPPING: import.meta.env.VITE_ID_RIO_ANIL_SHOPPING || "",
    VITE_ID_SHOPPING_METRO_SANTA_CRUZ: import.meta.env.VITE_ID_SHOPPING_METRO_SANTA_CRUZ || "",
    VITE_ID_SHOPPING_METROPOLE: import.meta.env.VITE_ID_SHOPPING_METROPOLE || "",
    // Lista de origens adicionais permitidas (separadas por vírgula)
    // Ex.: VITE_APP_ORIGINS="https://shoppingtiuca.lumis.com.br,https://www.seusite.com"
    APP_ORIGINS: (import.meta.env.VITE_APP_ORIGINS || "")
        .split(",")
        .map((item) => item.trim())
        .filter((item) => item.length > 0),
    apiAdmin: {
        apiBaseUrl: import.meta.env.VITE_API_ADMIN_URL || "http://localhost:8081",
        apiTimeout: parseInt(import.meta.env.VITE_API_ADMIN_TIMEOUT || "30000"), // 30 segundos
        apiSubscriptionKey: import.meta.env.VITE_API_ADMIN_SUBSCRIPTION_KEY || "",
    },
    apiRag: {
        apiBaseUrl: import.meta.env.VITE_API_RAG_URL || "http://localhost:8005", 
        apiTimeout: parseInt(import.meta.env.VITE_API_RAG_TIMEOUT || "30000"), // 30 segundos
        apiSubscriptionKey: import.meta.env.VITE_API_RAG_SUBSCRIPTION_KEY || "",
    },
    apiOrchestrator: {
        apiBaseUrl: import.meta.env.VITE_API_ORCHESTRATOR_URL || "http://localhost:8006",
        apiTimeout: parseInt(import.meta.env.VITE_API_ORCHESTRATOR_TIMEOUT || "30000"), // 30 segundos
        apiSubscriptionKey: import.meta.env.VITE_API_ORCHESTRATOR_SUBSCRIPTION_KEY || "",
    }
};

console.info('environment: ', values.NODE_ENV);
console.info('apiBaseUrl: ', values.API_URL);

export default Object.assign(values, import.meta.env); 